"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import $ from "jquery";
import Geosuggest from "react-geosuggest";
import "prop-types";
import ReactDOM from "react-dom";
import { attachOcrLineDropListeners, forceString } from "./ocr_line_drop";
const GeosuggestDroppableInput = React.createClass({
  componentDidMount() {
    var suggestInput = ReactDOM.findDOMNode(this.refs.input).children[0].children[0];
    $(suggestInput).droppable({
      drop: (event, ui) => {
        this.applyDroppedChars(ui.helper.data("chars"));
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.detachOcrLineDrop = attachOcrLineDropListeners(
      suggestInput,
      (payload) => this.applyDroppedChars(payload.chars)
    );
  },
  componentWillUnmount() {
    if (this.detachOcrLineDrop) {
      this.detachOcrLineDrop();
    }
  },
  applyDroppedChars(chars) {
    this.refs.input.update(forceString(chars));
    this.refs.input.focus();
  },
  cleanedProps() {
    const props = Object.assign({}, this.props);
    if (typeof props.inputDropped !== "undefined") {
      delete props.inputDropped;
    }
    if (props.initialValue === null) {
      props.initialValue = "";
    }
    return props;
  },
  render() {
    return /* @__PURE__ */ React.createElement(
      Geosuggest,
      __spreadProps(__spreadValues({
        "data-component": "GeosuggestDroppableInput",
        ref: "input"
      }, this.cleanedProps()), {
        onSuggestSelect: this.onSuggestSelect,
        onBlur: this.nonSelect
      })
    );
  },
  onSuggestSelect(suggest) {
    if (suggest == void 0) {
      this.props.geosuggestClear.requestChange();
      this.refs.input.clear();
    } else {
      this.props.valueLink.requestChange(suggest);
    }
  },
  nonSelect(value) {
    this.props.nonSelect.requestChange(value);
  }
});
export default GeosuggestDroppableInput;
